module.exports = __webpack_public_path__ + "static/media/sunset.77a83e2a.svg";